import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class LoginPhrase extends ModelBase {
  public static readonly type = 'LoginPhrase';
  public readonly type = LoginPhrase.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('group_id')
  public groupId: string;

  @autoserializeAs('text')
  public text: string;
}
